import * as React from "react";
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import NavBar from "../navbar";
import SeekerStore from "../../../stores/seekerStore";
import { View } from "../../../models/enums";
import Tabs, { Tab } from "material-ui/Tabs";
import { Auth } from "../../../utils/auth";
import LoginDlg from "../../dialogs/login";
import NavBarMobile from "../navbarMobile";
import RegistrationDlg from "../../dialogs/registration";
import RegistrationLiteDlg from "../../dialogs/registrationLite";

const headerStyle: any = {flexDirection: "row"};
const tabStyle: any = { textTransform: "none" }

@observer
export default class Header extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    const liteReg: boolean = this.props.store.localization && this.props.store.localization.fields ? this.props.store.localization.fields.register.useLiteRegistration : false;
    return (<div style={headerStyle}>
      <NavBar store={this.props.store} />
      <LoginDlg store={this.props.store} />
      {!liteReg && <RegistrationDlg store={this.props.store} />}
      {liteReg && <RegistrationLiteDlg store={this.props.store} />}
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/components/app/header/index.tsx